const CompanyMediaTypes = {
  Video: 1,
  Image: 2,
  EmbeddedVideo: 3,
  PDF: 4,
}

export default CompanyMediaTypes
